import React from 'react';
import PropTypes from 'prop-types';
import Certification from './Certification';
import WithImpressions from '../../../WithImpressions';

export default function Certifications({ certifications, biData }) {
    if (!certifications.length) { return null; }

    const seller_card_about_me_certifications = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_certifications_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_certifications' },
            element: {
                position: biData.position,
                type: 'text',
                metadata: 'Certifications',
                text: certifications.map((certification) => certification.certification_name).toString(),
                name: 'seller_card_about_me_certifications',
                visible: true
            }
        }
    };
    return (
        <WithImpressions className="list" value={seller_card_about_me_certifications}>
            <h3>{i18n.t('seller_profile.certifications')}</h3>
            <ul>
                {certifications.map((certification, idx) =>
                    <Certification certification={certification} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Certifications.propTypes = {
    certifications: PropTypes.array,
    biData: PropTypes.object
};

Certifications.defaultProps = {
    certifications: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Certifications/index.js